import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { Footer } from 'shared/components/Footer';
import { TRemoteSocial } from 'shared/types/socials';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { mapRemoteSocials } from 'shared/utils/socials/mapRemoteSocials';

export const FooterContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const remoteSocials = config.get<TRemoteSocial[]>('b2b-marketing-smb-promo-frontend.socials');

  const device = useDeviceType();

  const socialItems = useMemo(() => mapRemoteSocials(remoteSocials, device), [remoteSocials, device]);

  return <Footer socialItems={socialItems} device={device} />;
};
